var spanList = [...document.querySelectorAll('.colour__text')];
var wordList =[];
var colourList =[];

var c_options = {
  rootMargin: '-40% 0% -50% 0%',
  threshold: 0.0
}

spanList.forEach(findWords);

function findWords(word, i) {
  wordList.push(word.textContent.trim());
}

spanList.forEach(findColour);

function findColour(colour, i) {
  let style = window.getComputedStyle(colour);
  colourList.push(style.getPropertyValue("color"));
}

wordList.forEach(insert);

function insert(classname, i) {
  let text = document.getElementById("big__text").innerHTML; 
  document.getElementById("big__text").innerHTML = text.replace(classname, "<span class='highlight__text' style='color: " + colourList[i] + " '>" + classname + "</span>");
}

var classList = [...document.querySelectorAll('.highlight__text')];


let c_observer = new IntersectionObserver(paint, c_options);

function paint(days){
  days.forEach(day => {
    day.target.classList.toggle("colour__blocker", !day.isIntersecting)
  })  
}

classList.forEach(item =>{
  c_observer.observe(item); 
})
